import { createAction } from 'redux-actions';

import { updateBookingField } from 'actions/booking';
import {
	getUserProfessionOptionData,
	getUserInterestOptionData,
	getUserCareerOptionData,
} from 'actions/user';

import { mapUserLevel } from 'util/helper';
import { sessionStorage } from 'util/storage';

export const FIELD_ACTION_MAP = {
	auth: createAction('UPDATE_AUTH_FIELD', (type, key, value) => ({
		type,
		key,
		value,
	})),
	user: createAction('UPDATE_USER_FIELD', (type, key, value) => ({
		type,
		key,
		value,
	})),
	community: createAction('UPDATE_COMMUNITY_FIELD', (type, key, value) => ({
		type,
		key,
		value,
	})),
	booking: updateBookingField,
	reservation: createAction('UPDATE_RESERVATION_FIELD', (type, key, value) => ({
		type,
		key,
		value,
	})),
};

export const updateUserProfessionKeywordEpic = action$ =>
	action$
		.ofType('UPDATE_USER_FIELD')
		.debounceTime(500)
		.filter(
			action =>
				action.payload.key === 'professions' &&
				Object.keys(action.payload.value).includes('inputValue'),
		)
		.switchMap(async action => getUserProfessionOptionData(action.payload.value.inputValue));

export const updateUserInterestKeywordEpic = action$ =>
	action$
		.ofType('UPDATE_USER_FIELD')
		.debounceTime(500)
		.filter(
			action =>
				action.payload.key === 'interests' &&
				Object.keys(action.payload.value).includes('inputValue'),
		)
		.switchMap(async action => getUserInterestOptionData(action.payload.value.inputValue));

export const updateUserCareerKeywordEpic = action$ =>
	action$
		.ofType('UPDATE_USER_FIELD')
		.debounceTime(500)
		.filter(
			action =>
				action.payload.key === 'career' && Object.keys(action.payload.value).includes('inputValue'),
		)
		.switchMap(async action => getUserCareerOptionData(action.payload.value.inputValue));

export const syncUserSettingLocalStorageEpic = (action$, store) =>
	action$
		.ofType('UPDATE_USER_FIELD')
		.debounceTime(500)
		.filter(() => mapUserLevel(store.getState().user.data.levelId) === 'REGISTERED')
		.forEach(() => {
			sessionStorage.setItem('userForm', JSON.stringify(store.getState().user.form));
		});

export const syncUserSettingFromLocalStorage = createAction(
	'SYNC_USER_SETTING_FROM_LOCALSTORAGE',
	form => ({ form }),
);



// WEBPACK FOOTER //
// ./src/actions/bind.js